import { Injector } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { toQueryParams } from '@app/helpers/object.helpers';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { noticeError } from '@app/helpers/new-relic';
import { NzMessageService } from 'ng-zorro-antd';
import { path, prop } from '@ramda';
import { HttpStatusCode } from '@modules/shared/constants/http.enum';
import * as i0 from "@angular/core";
export function handleApiError(error, nzMessage, requestDetails) {
    if (requestDetails) {
        noticeError({
            message: 'API Request Failed',
            error,
            request: requestDetails,
        });
    }
    const handledErrors = [HttpStatusCode.BadRequest, HttpStatusCode.NotFound];
    const defaultMessage = 'Hubo un error el proceso.';
    if (!handledErrors.includes(prop('status', error))) {
        const errorMessage = path(['error', 'message'], error) || prop('message', error) || defaultMessage;
        nzMessage.error(errorMessage);
    }
    return throwError(error);
}
export class ApiService {
    constructor(injector) {
        this.injector = injector;
        this.railsApiUrl = environment.baseUrlRails;
        this.http = injector.get(HttpClient);
        this.nzMessage = injector.get(NzMessageService);
    }
    get(endpoint, params = {}) {
        const queryParams = Object.keys(params).length ? toQueryParams(params) : '';
        const url = `${this.railsApiUrl}${endpoint}${queryParams}`;
        return this.http.get(url).pipe(catchError((error) => handleApiError(error, this.nzMessage, {
            method: 'GET',
            url,
            params,
        })));
    }
    // POST request
    post(endpoint, body, headers) {
        const url = `${this.railsApiUrl}${endpoint}`;
        return this.http.post(url, body, { headers }).pipe(catchError((error) => handleApiError(error, this.nzMessage, {
            method: 'POST',
            url,
            body,
        })));
    }
    // PUT request
    put(endpoint, body, headers) {
        return this.http.put(`${this.railsApiUrl}${endpoint}`, body, { headers });
    }
    // DELETE request
    delete(endpoint, params, headers) {
        const url = `${this.railsApiUrl}${endpoint}`;
        return this.http.delete(`${this.railsApiUrl}${endpoint}`, { params, headers }).pipe(catchError((error) => handleApiError(error, this.nzMessage, {
            method: 'DELETE',
            url,
        })));
    }
    // PATCH request
    patch(endpoint, body, headers) {
        return this.http.patch(`${this.railsApiUrl}${endpoint}`, body, { headers });
    }
}
ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i0.INJECTOR)); }, token: ApiService, providedIn: "root" });
